module.exports = __webpack_public_path__ + "static/media/ep4.a19b86bb.jpg";